import { render, staticRenderFns } from "./DirectorShiftsDescription.vue?vue&type=template&id=43976578&lang=pug&"
import script from "./DirectorShiftsDescription.vue?vue&type=script&lang=js&"
export * from "./DirectorShiftsDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports